module.exports = __webpack_public_path__ + "img/icon-rights-success.95ccadf9.svg";